module.exports = __webpack_public_path__ + "media/images/organizational_culture-7c8daf7630efb1b0dac83d965f147d38.png";